import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.sort.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-14e82176"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传文件");

const _hoisted_2 = {
  class: "image-slot"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部团队");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("部分团队");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加团队");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { addCarouselConfigure, getCarouselConfigureList } from '@/request';
import { eachObj, arrayRemoveRepeatByProp } from '@/utils';
import AddTeamModal from '@/components/AddTeamModal.vue';
import { useStore } from 'vuex';
export default {
  name: 'AddCarouselConfigureModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    isSee: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    },
    dictList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const store = useStore();
    const userType = computed(() => store.state.user.userType);
    const formRef = ref();
    const uploadRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const scroll = ref();
    const defaultForm = {
      supSlideshowConfigId: '',
      adminFlag: 1,
      branchFlag: 1,
      areaFlag: 1,
      supplierFlag: 1,
      slideshowType: '1',
      sort: 1,
      areaIds: '',
      fileName: '',
      slideshowUrl: '',
      link: ''
    };
    const form = ref(_objectSpread({}, defaultForm));
    watch(() => props.modelValue, newVal => {
      scroll.value.setScrollTop(0);

      if (newVal && !props.editData) {
        var _formRef$value;

        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
        uploadRef.value.clearFiles();
        form.value = _objectSpread({}, defaultForm);
      }

      if (newVal && props.editData) {
        var _props$editData$areaI;

        getDetail();
        form.value = {
          supSlideshowConfigId: props.editData.supSlideshowConfigId,
          adminFlag: 1,
          branchFlag: 1,
          areaFlag: 1,
          supplierFlag: props.editData.supplierFlag,
          slideshowType: props.editData.slideshowType + '',
          sort: 1,
          title: props.editData.title,
          areaIds: (_props$editData$areaI = props.editData.areaIdsStr) === null || _props$editData$areaI === void 0 ? void 0 : _props$editData$areaI.split(','),
          slideshowUrl: props.editData.slideshowUrl,
          link: props.editData.link,
          fileURl: props.editData.slideshowUrl,
          fileName: decodeURIComponent(props.editData.slideshowUrl).split('/').pop()
        };
      }
    }, {
      flush: 'post'
    });

    function validUrl(rule, val, cb) {
      if (val && !/^http(s)?:\/\//.test(val)) {
        cb(new Error());
        return;
      }

      cb();
    }

    function uploadChange(file) {
      if (file.size / 1024 / 1024 > 0.4) {
        uploadRef.value.clearFiles();
        ElMessage.error('文件大小不可超过 400kb!');
        return;
      }

      console.log(!/.(jp(e)?g|png|gif)$/.test(file.name));

      if (!/.(jp(e)?g|png|gif)$/.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png,gif格式的文件');
        return;
      }

      form.value.fileName = file.name;
      form.value.pic_file = file.raw;
      form.value.fileURl = URL.createObjectURL(new Blob([file.raw], {
        type: 'image/png'
      }));
    }

    function confirm() {
      formRef.value.validate(result => {
        console.log(tableData.value);

        if (result) {
          const formdata = new FormData();

          const payload = _objectSpread({}, form.value);

          delete payload.areaIds;
          eachObj(payload, (key, val) => {
            formdata.append(key, val);
          }); // if (form.value.areaIds) {
          //   form.value.areaIds.forEach((val) => {
          //     formdata.append('areaIds', val);
          //   });
          // }

          if (form.value.supplierFlag === 2 && tableData.value.length) {
            formdata.append('supplierIds', tableData.value.map(v => v.supplier_id));
          }

          formdata.delete('receiveSuppliers');
          addCarouselConfigure(formdata, {
            params: {
              __warn: true,
              __repeat: true
            }
          }).then(data => {
            if (data.success) {
              ElMessage.success('操作成功!');
              emit('success');
            }
          });
        }
      });
    } // 团队列表


    const table = ref();
    const tableData = ref([]);
    const tableOptions = {
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '团队名称',
        field: 'supplier_name',
        width: '200px',
        showOverflow: true
      }, {
        title: '业务员数量',
        field: 'salesman_num'
      }, {
        title: '联系人',
        field: 'link_man'
      }, {
        title: '联系电话',
        field: 'link_phone'
      }, {
        title: '业务区域',
        field: 'businessAreaName',
        showOverflow: true
      }]
    };
    const showAddTeamModal = ref(false);

    function addTeamSuccess(row) {
      tableData.value = arrayRemoveRepeatByProp((tableData.value || []).concat(row), 'id');
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      tableData.value = tableData.value.filter(row => selectRows.every(select => select.supplier_id !== row.supplier_id));
    } // 获取详情


    function getDetail() {
      getCarouselConfigureList({
        supSlideshowConfigId: props.editData.supSlideshowConfigId,
        page: 1,
        rows: 1000
      }).then(res => {
        let list = res.rows[0].receiveSuppliers || [];
        tableData.value = list.map(item => ({
          supplier_name: item.supplierName,
          salesman_num: item.salesmanNumbs,
          link_man: item.linkMan,
          link_phone: item.linkPhone,
          businessAreaName: item.businessAreaName,
          supplier_id: item.supplierId
        }));
      });
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_PictureFilled = _resolveComponent("PictureFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.editData ? '编辑' : '新增',
        top: "30px",
        width: "80%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          style: {
            "padding": "10px"
          },
          ref_key: "scroll",
          ref: scroll
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            align: "left",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "轮播图类型",
              prop: "slideshowType",
              rules: {
                required: true,
                message: '请输入活动名称'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                disabled: "",
                modelValue: form.value.slideshowType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.slideshowType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "普通轮播图",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "B2B礼包活动",
                  value: "2"
                }), _createVNode(_component_el_option, {
                  label: "直播分享(微信官方直播)",
                  value: "3"
                }), _createVNode(_component_el_option, {
                  label: "直播分享(B2B小程序))",
                  value: "4"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "排序",
              prop: "sort"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: form.value.sort,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.sort = $event),
                disabled: __props.isSee,
                min: 1,
                max: 5
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "选择文件",
              prop: "fileName",
              rules: {
                required: true,
                message: '请上传文件'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                disabled: __props.isSee,
                style: {
                  "width": "300px"
                },
                readonly: "",
                modelValue: form.value.fileName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.fileName = $event)
              }, null, 8, ["disabled", "modelValue"]), !__props.isSee ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 0,
                ref_key: "uploadRef",
                ref: uploadRef,
                multiple: false,
                "show-file-list": false,
                "on-change": uploadChange,
                "auto-upload": false,
                style: {
                  "margin-left": "10px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, null, {
                  default: _withCtx(() => [_hoisted_1]),
                  _: 1
                })]),
                _: 1
              }, 512)) : _createCommentVNode("", true)]),
              _: 1
            }), !__props.isSee ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              style: {
                "margin-top": "10px"
              },
              title: "尺寸：1005*210px 大小：最大400kb 格式：jpg,jpeg,png,gif",
              type: "warning"
            })) : _createCommentVNode("", true), _createVNode(_component_el_image, {
              class: "image",
              src: form.value.fileURl,
              style: {
                "width": "400px",
                "height": "200px"
              },
              fit: "contain",
              previewSrcList: [form.value.slideshowUrl]
            }, {
              error: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_PictureFilled)]),
                _: 1
              })])]),
              _: 1
            }, 8, ["src", "previewSrcList"]), _createVNode(_component_el_form_item, {
              label: "链接",
              prop: "link",
              rules: [{
                validator: validUrl,
                message: '链接以http:// 或 https:// 开头'
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.link,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.link = $event),
                disabled: __props.isSee
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            }, 8, ["rules"]), _createVNode(_component_el_form_item, {
              prop: "title",
              label: "页面标题",
              rules: {
                required: true,
                message: '请填写页面标题'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                disabled: __props.isSee,
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.title = $event)
              }, null, 8, ["disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              prop: "supplierFlag",
              label: "接收团队",
              rules: {
                required: true,
                message: '请选择接收团队'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: form.value.supplierFlag,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.supplierFlag = $event)
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_hoisted_3]),
                  _: 1
                }, 512), [[_vShow, _unref(userType) === 1 || _unref(userType) === 2]]), _createVNode(_component_el_radio, {
                  label: 2
                }, {
                  default: _withCtx(() => [_hoisted_4]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _withDirectives(_createVNode(_component_vxe_grid, _mergeProps(tableOptions, {
              data: tableData.value,
              ref_key: "table",
              ref: table
            }), {
              tools: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_button, {
                icon: "Plus",
                type: "primary",
                onClick: _cache[6] || (_cache[6] = $event => showAddTeamModal.value = true)
              }, {
                default: _withCtx(() => [_hoisted_5]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "Delete",
                type: "danger",
                onClick: del
              }, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
              })], 512), [[_vShow, !__props.isSee]])]),
              _: 1
            }, 16, ["data"]), [[_vShow, form.value.supplierFlag === 2]])]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 512), _createVNode(AddTeamModal, {
          modelValue: showAddTeamModal.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showAddTeamModal.value = $event),
          onSuccess: addTeamSuccess
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};